import { X } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTrigger,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

import { useSoftwareEscrowNewContext } from '../model';

const ExitAlertDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { appId } = useSoftwareEscrowNewContext();
  const onClose = () => navigate(`/applications/${appId}`);

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="shadow-none sm:absolute sm:top-5 sm:right-6 sm:z-2"
          aria-label="Exit"
        >
          <X />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Your changes won’t be saved</AlertDialogTitle>
          <AlertDialogDescription>This escrow won’t be saved if you exit this screen.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="outline">Cancel</Button>
          </AlertDialogCancel>
          <Button onClick={onClose}>Exit anyway</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ExitAlertDialog;
